import { useTranslation } from 'react-i18next';

import { AllWalletsTable } from '@/features/wallets/components/AllWallets/AllWalletsTable';
import { Page } from '@/ui-kit/templates/Page';

export function WalletsPage() {
  const { t } = useTranslation();
  return (
    <Page title={t('layout.sidebar.links.wallets')}>
      <AllWalletsTable />
    </Page>
  );
}

export default WalletsPage;
